import React, { Component } from 'react';
import { Container, Row, Col } from 'Components/Grid';
import classnames from 'classnames';
import Button from 'Components/Button';
import styles from './styles.scss';

export default class TableOfContents extends Component {
  render() {
    const { offerListModel: offers, onSelect, background } = this.props;
    const items = offers.items.filter((item) => item.offerCategory !== 'LureOffer');

    if (offers.items.some((item) => item.offerCategory === 'LureOffer')) {
      items.push(offers.items.find((item) => item.offerCategory === 'LureOffer'));
    }

    return (
      <div className={classnames(styles.entry, background)}>
        <Container>
          <Row>
            <Col>
              <h4 className={styles.tableOfContentsHeader}>Wählen sie Ihr Angebot aus</h4>

              {items.map(({ headline1, headline2, offerCategory }, index) => (
                <div className={styles.tableOfContentsRow} key={`${headline1 + headline2}-index`}>
                  <span className={styles.tableOfContentHeadline}>
                    {offerCategory === 'LureOffer'
                      ? 'Weitere Angebote'
                      : `${headline1} ${headline2 || ''}`}
                  </span>

                  <Button
                    className={styles.tableOfContentOfferButton}
                    label="Zum Angebot"
                    type="secondary"
                    onClick={() => onSelect && onSelect(index)}
                  />
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
